import { RaceStatus } from '@mobi/api-types/racePage/types'
import type { RacingBetType } from '@mobi/betslip/types'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'
import { previewTipsTracker } from '../RaceContent/helpers/analytics'

const trackTipsBetClickedEvent = (
  key: typeof keys.tipsBetClicked | typeof keys.racePreviewBetClicked,
  meetingCode: string,
  meetingName: string,
  buttonPosition: number,
  betType: RacingBetType
) =>
  trackEvent(key, {
    meetingCode,
    meetingName,
    buttonPosition,
    betType,
  })

export const trackTipsBetClicked = (
  meetingCode: string,
  meetingName: string,
  buttonPosition: number,
  betType: RacingBetType
) =>
  trackTipsBetClickedEvent(keys.tipsBetClicked, meetingCode, meetingName, buttonPosition, betType)

export const trackRacePreviewBetClicked = (
  meetingCode: string,
  meetingName: string,
  buttonPosition: number,
  betType: RacingBetType
) =>
  trackTipsBetClickedEvent(
    keys.racePreviewBetClicked,
    meetingCode,
    meetingName,
    buttonPosition,
    betType
  )

export const trackPreviewTipsBetClicked = (
  meetingName: string,
  author: string,
  raceCode: string,
  raceStatus?: RaceStatus,
  betType?: string
) => {
  previewTipsTracker({
    interaction_type: 'Bet Clicked',
    author,
    raceCode,
    meetingName,
    raceStatus,
    betType,
  })
}
